import { render, staticRenderFns } from "./section-results.vue?vue&type=template&id=6c747cec&scoped=true&"
import script from "./section-results.vue?vue&type=script&lang=js&"
export * from "./section-results.vue?vue&type=script&lang=js&"
import style0 from "./section-results.vue?vue&type=style&index=0&id=6c747cec&lang=scss&scoped=true&"
import style1 from "./section-results.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c747cec",
  null
  
)

export default component.exports